import { ReactNode } from 'react';
import { useIntl } from 'react-intl';

import { useStyles } from './app-benefit.styles';
import { ItemWithIcon } from '../../../../../common/card';


export const AppBenefit = ({ icon, item }: ItemWithIcon): JSX.Element => {
  const classes = useStyles();
  const intl = useIntl();

  return (
    <div className={classes.root} data-testid="app-benefit-wrapper">
      <span
        aria-hidden="true"
        className={classes.iconWrapper}
        data-testid="icon-wrapper"
      >
        {icon}
      </span>
      <span
        data-testid="item"
        className={classes.item}
      >
        {intl.formatMessage(
          { id: item },
          {
            sup: (chunks: ReactNode) => <sup>{chunks}</sup>,
            span: (chunks: ReactNode) => <span className={classes.newLine}>{chunks}</span>,
          },
        )}
      </span>
    </div>
  );
};
